<template>
  <div style="max-width: 1130px; margin: auto">
    <div style="display: flex; justify-content:space-between; align-items: center; margin-bottom: 1rem">
      <div class="title">班級通知</div>
      <div v-if="isTeacher">
        <AddMsg :courseId="courseId"/>
      </div>
    </div>
      <div v-show="false" style="text-align:center">
        <el-radio-group v-model="mailBox" @change="changeMailBox">
          <el-radio-button label="received">收件匣</el-radio-button>
          <el-radio-button label="sent">寄件匣</el-radio-button>
        </el-radio-group>
      </div>
      <div v-show="!isLoading">
        <el-table
          empty-text="沒有通知"
          ref="filterTable"
          :data="currentMsg"
          style="width: 100%;"
          :row-class-name="tableRowClassName"
          header-row-class-name="rowTitle"
        >
          <el-table-column
            prop="created_datetime"
            label="日期"
            sortable
            :width="widths.created_datetime"
            column-key="date"
          />
          <el-table-column
            prop="sender"
            label="訊息來源"
            :width="widths.sender"
            :filters="senderList"
            :filter-method="filterHandler"
          />
          <el-table-column
            prop="title"
            label="主旨"
            :width="widths.title"
            class-name="title-cell"
          />
          <el-table-column
            prop="action"
            label="動作"
            :width="widths.action"
          >
            <template slot-scope="scope">
              <el-button @click="showDetail(scope.row.id)" size="mini">查看</el-button>
              <el-button v-show="mailBox==='received'" @click="changeStatus(scope.row.id)" size="mini">{{ scope.row.is_read?'標記為未讀':'標記為已讀' }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align: center; margin-top: 1rem">
        <el-pagination
          layout="prev, pager, next"
          @current-change="changePage"
          :total="this.total">
        </el-pagination>
      </div>
      <Loading v-show="isLoading"></Loading>
      <DetailMsg ref="detail" />
    </div>
</template>
<style lang="scss">
.title{
  color: #387E1E;
  font-size: 1.5rem;
  font-weight: 600;
}
.el-table .unread-row{
  background: #f1fdda;
}
.rowTitle{
  font-size: 1.3rem;
  font-weight: 600;
  color: #387E1E;
  background-color: #99CB32 !important;
}
@media screen and (max-width: 790px) {
  .title-cell .cell{
    overflow-x: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }
}
</style>
<script>
import AddMsg from '@/components/Announcements/AddMsg'
import DetailMsg from '@/components/Announcements/DetailMsg'
import Loading from '@/components/Utility/Loading.vue'
export default {
  components: {
    AddMsg,
    DetailMsg,
    Loading
  },
  data () {
    return {
      isLoading: true,
      mailBox: 'received',
      currentMsg: [],
      senderList: [],
      offset: 0,
      limit: 10,
      total: null,
      has_next: false,
      allMsg: {
        received: {
          msg: [],
          offset: 0
        },
        sent: {
          msg: [],
          offset: 0
        }
      },
      courseId: this.$parent.courseId
      // overflowCellStyle: {
      //   'overflow-x': 'hidden',
      //   'text-overflow': 'ellipsis',
      //   'white-space': 'nowrap'
      // }
    }
  },
  methods: {
    changePage: function (page) {
      if (this.mailBox === 'received') {
        this.currentMsg = this.allMsg.received.msg.slice(this.limit * (page - 1), this.limit * (page - 1) + this.limit)
      } else if (this.mailBox === 'sent') {
        this.currentMsg = this.allMsg.sent.msg.slice(this.limit * (page - 1), this.limit * (page - 1) + this.limit)
      }
    },
    update: function (mailBox, offset = false) {
      // update the content
      if (mailBox === 'received') {
        this.mailBox = mailBox
        if (offset === false) {
          this.offset = this.allMsg.received.offset
        } else {
          this.allMsg.received.offset = offset
          this.offset = offset
        }
        this.currentMsg = this.allMsg.received.msg.slice(this.offset, this.offset + this.limit)
        this.has_next = this.allMsg.received.msg.length > (this.offset + this.limit)
      } else if (mailBox === 'sent') {
        this.mailBox = mailBox
        if (offset === false) {
          this.offset = this.allMsg.sent.offset
        } else {
          this.allMsg.sent.offset = offset
          this.offset = offset
        }
        this.currentMsg = this.allMsg.sent.msg.slice(this.offset, this.offset + this.limit)
        this.has_next = this.allMsg.sent.msg.length > (this.offset + this.limit)
      }
      console.log(this.mailBox)
    },
    changeMailBox: function (mailBox) {
      this.update(mailBox)
      // if (this.mailBox === mailBox) {
      //   // do nothing
      // } else {
      //   this.update(mailBox)
      // }
    },
    showDetail: function (boardcastID) {
      // data-toggle="modal" data-target="#view_broadcast"
      for (let message of this.currentMsg) {
        if (boardcastID === message.id) {
          if (this.mailBox === 'received' && !message.is_read) {
            this.changeStatus(boardcastID)
          }
          return this.$refs.detail.update(message)
        }
      }
      alert('更新失敗')
    },
    changeStatus: function (boardcastID) {
      if (this.mailBox === 'received') {
        let found = false
        for (let message of this.allMsg.received.msg) {
          if (boardcastID === message.id) {
            message.is_read = !message.is_read
            found = true
          }
        }
        if (found) {
          let fd = new FormData()
          fd.append('announcement_id', this.boardcastID)
          this.$store.dispatch('request', {
            route: `announcements/${boardcastID}`,
            method: 'post',
            body: fd
          })
        }
      }
    },
    previousPage: function () {
      this.update(this.mailBox, this.offset - this.limit)
    },
    nextPage: function () {
      this.update(this.mailBox, this.offset + this.limit)
    },
    fetchMsg: async function () {
      let fd = new FormData()
      fd.append('course_id', this.courseId)
      console.log(this.isStudent, this.isTeacher)
      try {
        if (this.isStudent) {
          await this.$store.dispatch('request', {
            route: 'announcements/received',
            data: fd
          }).then(res => {
            this.allMsg.received.msg = res.map(msg => {
              if (this.isMobile) {
                msg.created_datetime = msg.created_datetime.split(' ')[0]
              }
              return msg
            })
            this.allMsg.received.offset = 0
            this.total = res.length
            for (let i = 0; i < res.length; i++) {
              console.log(this.senderList)
              let found = this.senderList.some(el => el.value === res[i].sender)
              if (!found) this.senderList.push({ value: res[i].sender, text: res[i].sender })
            }
            console.log(this.senderList)
            console.log(res.length)
            console.log(this.totalPage)
            // only for first time
            this.mailBox = 'received'
            this.offset = this.allMsg.received.offset
            this.currentMsg = this.allMsg.received.msg.slice(this.offset, this.offset + this.limit)
            this.has_next = this.allMsg.received.msg.length > (this.offset + this.offset + this.limit)
            this.changeMailBox('received')
          })
        }

        if (this.isTeacher) {
          await this.$store.dispatch('request', {
            route: 'announcements/sent',
            data: fd
          }).then(res => {
            this.total = res.length
            this.allMsg.sent.msg = res.map(msg => {
              if (this.isMobile) {
                msg.created_datetime = msg.created_datetime.split(' ')[0]
              }
              return msg
            })
            console.log(this.allMsg)
            this.allMsg.sent.offset = 0
            this.changeMailBox('sent')
            console.log(this.$store.getters.user.name)
            this.allMsg.sent.msg.forEach(msg => {
              msg.sender = msg.sender === this.$store.getters.user.name ? '班級通知' : '系統通知'
            })
          })
        }
      } catch (err) {
        console.log(err)
        alert('更新失敗')
      }
      console.log(this.allMsg)
      this.isLoading = false
    },
    resetDateFilter () {
      this.$refs.filterTable.clearFilter('date')
    },
    clearFilter () {
      this.$refs.filterTable.clearFilter()
    },
    formatter (row, column) {
      return row.address
    },
    filterTag (value, row) {
      return row.tag === value
    },
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    tableRowClassName ({ row, rowIndex }) {
      if (this.mailBox === 'received' && !row.is_read) {
        console.log(row.is_read)
        return 'unread-row'
      } else {
        return ''
      }
    }
  },
  computed: {
    widths: function () {
      if (!this.isMobile) {
        return {
          created_datetime: 200,
          sender: 150,
          title: 550,
          action: 200
        }
      } else {
        return {
          created_datetime: 100,
          sender: 80,
          title: 120,
          action: 80
        }
      }
    },
    isMobile: function () {
      return window.screen.width < 790
    },
    isTeacher: function () {
      return this.$store.getters.isTeacher
    },
    isStudent: function () {
      return this.$store.getters.isStudent
    }
  },
  mounted: function () {
    console.log(this.$parent.role)
    this.fetchMsg()
  }
}
</script>
